<div [ngClass]="{'selected': toggle}">
  <div class="record-item" (click)="toggle = !toggle">
    <p [ngClass]="{'saturday': isSaturday(reportRecord) && !isSunday(reportRecord), 'sunday': isSunday(reportRecord)}">{{ reportRecord.dateTextShort }}</p>
    <p [ngClass]="{'accent': status === 0, 'primary': status === 1, 'warn': status === 2}">{{ reportRecord.cells[0].toString() }}</p>
    <p [ngClass]="{'accent': status === 0, 'primary': status === 1, 'warn': status === 2}">{{ reportRecord.cells[1].toString() }}</p>
    <p [ngClass]="{'accent': status === 0, 'primary': status === 1, 'warn': status === 2}">{{ reportRecord.cells[2].toString() }}</p>
    <p [ngClass]="{'accent': status === 0, 'primary': status === 1, 'warn': status === 2}">{{ reportRecord.cells[3].toString() }}</p>
    <p class="status" *ngIf="status === -1"></p>
    <mat-icon class="status-icon" *ngIf="status >= 0" [matTooltip]="statusTitle[status]" matTooltipPosition="below">{{ statusIcon[status] }}</mat-icon>
    <mat-icon class="toggle-icon" *ngIf="!toggle">expand_more</mat-icon>
    <mat-icon class="toggle-icon" *ngIf="toggle">expand_less</mat-icon>
  </div>
  <div class="expand-item" [hidden]="!toggle">
    <hr>
    <div>
      <p>実打刻</p>
      <p *ngIf="reportDate[0].length === 0">-</p>
      <div class="shift-stamp-button-list" *ngIf="reportDate[0].length !== 0">
        <ng-container *ngFor="let date of reportDate[0]">
          <button *ngIf="date.shiftEditable && canShiftEdit" class="shift-stamp-button" mat-button (click)="openShiftStampDialog(reportRecord, date.stamp)">
            <span [ngClass]="{'shift-stamp-button-text': !date.ejectFlag,'shift-stamp-button-eject-text': date.ejectFlag}">{{ date.dateText }}</span>
          </button>
          <button *ngIf="!date.shiftEditable || !canShiftEdit" class="shift-stamp-button" mat-button (click)="onEjectedStamp()">
            <span [ngClass]="{'shift-stamp-button-text': !date.ejectFlag,'shift-stamp-button-eject-text': date.ejectFlag}">{{ date.dateText }}</span>
          </button>
        </ng-container>
      </div>
      <p *ngIf="reportDate[1].length === 0">-</p>
      <div class="shift-stamp-button-list" *ngIf="reportDate[1].length !== 0">
        <ng-container *ngFor="let date of reportDate[1]">
          <button *ngIf="date.shiftEditable && canShiftEdit" class="shift-stamp-button" mat-button (click)="openShiftStampDialog(reportRecord, date.stamp)">
            <span [ngClass]="{'shift-stamp-button-text': !date.ejectFlag,'shift-stamp-button-eject-text': date.ejectFlag}">{{ date.dateText }}</span>
          </button>
          <button *ngIf="!date.shiftEditable || !canShiftEdit" class="shift-stamp-button" mat-button (click)="onEjectedStamp()">
            <span [ngClass]="{'shift-stamp-button-text': !date.ejectFlag,'shift-stamp-button-eject-text': date.ejectFlag}">{{ date.dateText }}</span>
          </button>
        </ng-container>
      </div>
      <p *ngIf="reportDate[2].length === 0">-</p>
      <div class="shift-stamp-button-list" *ngIf="reportDate[2].length !== 0">
        <ng-container *ngFor="let date of reportDate[2]">
          <button *ngIf="date.shiftEditable && canShiftEdit" class="shift-stamp-button" mat-button (click)="openShiftStampDialog(reportRecord, date.stamp)">
          <span [ngClass]="{'shift-stamp-button-text': !date.ejectFlag,'shift-stamp-button-eject-text': date.ejectFlag}">{{ date.dateText }}</span>
          </button>
          <button *ngIf="!date.shiftEditable || !canShiftEdit" class="shift-stamp-button" mat-button (click)="onEjectedStamp()">
            <span [ngClass]="{'shift-stamp-button-text': !date.ejectFlag,'shift-stamp-button-eject-text': date.ejectFlag}">{{ date.dateText }}</span>
          </button>
        </ng-container>
      </div>
      <p *ngIf="reportDate[3].length === 0">-</p>
      <div class="shift-stamp-button-list" *ngIf="reportDate[3].length !== 0">
        <ng-container *ngFor="let date of reportDate[3]">
          <button *ngIf="date.shiftEditable && canShiftEdit" class="shift-stamp-button" mat-button (click)="openShiftStampDialog(reportRecord, date.stamp)">
          <span [ngClass]="{'shift-stamp-button-text': !date.ejectFlag,'shift-stamp-button-eject-text': date.ejectFlag}">{{ date.dateText }}</span>
          </button>
          <button *ngIf="!date.shiftEditable || !canShiftEdit" class="shift-stamp-button" mat-button (click)="onEjectedStamp()">
            <span [ngClass]="{'shift-stamp-button-text': !date.ejectFlag,'shift-stamp-button-eject-text': date.ejectFlag}">{{ date.dateText }}</span>
          </button>
        </ng-container>
      </div>
      <p class="status"></p>
      <mat-icon *ngIf="!canShiftEdit" matTooltip="ふりわけ変更不可" matTooltipPosition="right" class="toggle-icon">edit_off</mat-icon>
    </div>
    <hr class="dashed-border">
    <div>
      <p>申請</p>
      <p>{{ request[0] }}</p>
      <p>{{ request[1] }}</p>
      <p>{{ request[2] }}</p>
      <p>{{ request[3] }}</p>
      <p class="status"><button mat-button  class="request-status" (click)="showDateInfo(reportRecord)">{{ status !== -1 ? '詳細' : '' }}</button></p>
      <div class="request-button">
        <button mat-icon-button matTooltip="申請" matTooltipPosition="right" (click)="openDialog(reportRecord)">
          <mat-icon class="toggle-icon">create</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
